export default __webpack_public_path__ + "static/media/Screen Shot 2023-05-20 at 1.31.55 PM.66d6ac30.png";